
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Users, BookText } from "lucide-react";

export function AdminActions() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col space-y-3 mt-4">
      <Button
        variant="outline"
        className="border-red-200 text-red-700 hover:bg-red-50"
        onClick={() => navigate("/admin/congregations")}
      >
        <Users className="w-4 h-4 mr-2" /> Manage Congregations
      </Button>
      
      <Button
        variant="outline"
        className="border-red-200 text-red-700 hover:bg-red-50"
        onClick={() => navigate("/admin/sermon-plans")}
      >
        <BookText className="w-4 h-4 mr-2" /> Manage Sermon Plans
      </Button>
    </div>
  );
}
